import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../utils/SectionProps';
import ButtonGroup from '../components/elements/ButtonGroup';
import Button from '../components/elements/Button';

import Modal from '../components/elements/Modal';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Contact = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              Contact <span className="text-color-primary">Us</span>
            </h1>
            <br/><br/>
            <div className="container-xs">
                <h4>Office Address</h4>
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              Plot No. 29
Durga Nagar Park
Bidhannagar 
Durgapur,
Pin 713206
                </p>
              
            </div>
          </div>
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
           <p><strong>Gmail:</strong><a href = "mailto: clicco373@gmail.com"> clicco373@gmail.com</a></p>

          <p><strong>Call us:</strong> <a href="tel:+917001788383">7001788383</a> / <a href="tel:+917477371391">7477371391</a></p>
            
          </div>
          
        </div>
      </div>
    </section>
  );
}



export default Contact;